<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
		</ExpansionPanel>
		<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

export default {
	name: 'LoomFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: { SettingSwitch, ExpansionPanel },
};
</script>

<style scoped>
.clr_box {
	background: #fcfcfd;
	width: 90px;
	height: 30px;
	border: 1px solid #c7cad5;
	border-radius: 5px;
	text-transform: uppercase;
	position: relative;
	display: inline-block;
	overflow: hidden;
}
.clr_num h5 {
	line-height: 30px;
	color: #8e949d;
}
.clr_right {
	width: 30px;
	height: 30px;
	position: absolute;
	right: 0px;
	top: 0px;
	border-left: 1px solid #c7cad5;
}
.clr_sel {
	height: 200px;
	overflow: hidden;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
}
</style>
